import {Component, OnDestroy, OnInit} from '@angular/core';
import {CustomerService} from '../../../services/customer.service';
import {CustomerModel} from '../../../models/customer.model';
import {DomSanitizer} from '@angular/platform-browser';
import {SharedService} from '../../../services/shared.service';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import * as _ from 'lodash';
import {MatSnackBar} from '@angular/material';
import {SNACK_CONFIG} from '../../../global';

@Component({
  selector: 'app-promos',
  templateUrl: './promos.component.html',
  styleUrls: ['./promos.component.scss']
})
export class PromosComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  showHowItWorks: boolean;
  customer: CustomerModel;
  smsLink: string;
  emailLink: string;
  showLoader: boolean;
  promoCounter: number = 0;
  promoCodeClaim: string;

  constructor(private customerService: CustomerService,
              private sanitizer: DomSanitizer,
              private snack: MatSnackBar,
              private shared: SharedService) {
  }

  ngOnInit() {
    this.refreshCustomerInfo(null);
    this.customerService.getCustomerPromos()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(promos => {
        this.promoCounter = _.filter(promos, (p) => {
          return p.status && p.type == 'referrals';
        }).length;
        let firstTime = _.filter(promos, (p) => {
          return p.status && p.type == 'firstTimeReferredBy';
        });
        if (firstTime.length) this.promoCounter++;
      });
  }

  refreshCustomerInfo(force) {
    this.customerService.getCurrentCustomer(force)
      .then(customer => {
        this.customer = customer;
        if (customer.promoCode) {
          this.smsLink = 'sms:?body=Download Wahii for the best prices in fuel delivery and 5% off with my referral link  ' +
            'https://wahii.app.link/referral?code=' + customer.promoCode;
          this.emailLink = 'mailto:?subject=5% Off with Wahii&body=Download Wahii for the best prices in fuel delivery and 5% off with my referral link ' +
            'https://wahii.app.link/referral?code=' + customer.promoCode;
        } else this.generateCode();

      });
  }

  claimPromo(code: string) {
    this.showLoader = true;
    this.customerService.getCurrentCustomer()
      .then(customer => {
        let data = {
          promoCode: code,
          phone: customer.phone,
          countryCode: '+1'
        };
        return this.customerService.claimPromo(data);
      })
      .then(_ => {
        this.showLoader = false;
        this.promoCodeClaim = null;
        this.snack.open('Promo code claimed', null, SNACK_CONFIG);
      })
      .catch(err => {
        this.showLoader = false;
        let error = err.error;
        let message = err.errorMessage || error.errorMessage || 'Unexpected error. Please try again';
        this.shared.openErrorDialog({title: 'Error', body: message});
      });
  }

  generateCode() {
    this.showLoader = true;
    this.customerService.generatePromoCode()
      .then(() => {
        this.refreshCustomerInfo(true);
        this.showLoader = false;
      })
      .catch(() => {
        this.showLoader = false;
        this.shared.openErrorDialog({title: 'Error', body: 'Promo code error. Please try to reload the page.'});
      });
  }

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
